import React from "react";

import { Map } from "immutable";

import {
	AttachmentsBaseClass,
	type AttachmentsBaseProps,
	type AttachmentsBaseState,
	type FellowAttachment,
} from "~/attachments";
import AttachmentDropzone from "~/attachments/AttachmentDropzone";

interface AttachmentsPublicProps extends AttachmentsBaseProps {
	refetchFn: () => void;
	attachments: FellowAttachment[];
	publicLinkId: string;
}

export class AttachmentsPublic extends AttachmentsBaseClass<AttachmentsPublicProps, AttachmentsBaseState> {
	state: AttachmentsBaseState = {
		previewCache: Map(),
	};

	socketGroupMetadata() {
		return {
			publicLinkId: this.props.publicLinkId,
		};
	}

	_refresh() {
		this.props.refetchFn();
	}

	render() {
		const { attachments } = this.props;

		return (
			<AttachmentDropzone
				readonly={true}
				contentId={this.props.groupId}
				attachments={attachments}
				previewCache={this.state.previewCache}
			/>
		);
	}
}
